const rolesToString = (roles) => {
  if(roles.length)
    return roles.reduce((allRoles: string, role) => allRoles += `${role?.description}${prefixComma(allRoles)}`, '');
  else
    return '';
}

const prefixComma = (string) => {
  return (string.length) ? ',' : '';
}

export default rolesToString;
